<template>
	<div class="k-key-value" :style="{ '--columns': resolvedColumns, '--key-width': keyWidth }">
		<div v-for="(row, rowIndex) in rows" :key="rowIndex" class="k-key-value-row" :class="{ 'k-key-value-row--dark': rowIndex % 2 === 1 }">
			<div v-for="(item, colIndex) in row" :key="`${rowIndex}-${colIndex}`" class="k-key-value-pair">
				<div class="k-key-value-key">{{ item.key }}</div>
				<div class="k-key-value-value">
					<template v-if="hasValueSlot">
						<slot name="value" :value="item.value"></slot>
					</template>
					<template v-else>
						{{ item.value }}
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'KKeyValue',
	props: {
		items: {
			type: [Array,Object],
			required: true,
			validator: (value) => {
				if (typeof(value) == "Array") {
					value.every(item => 'key' in item && 'value' in item)
				}
				if (typeof(value == "object")) return true;
			}
		},
		keyWidth: {
			type: String,
			default: '40%'
		},
		columns: {
			type: [Number,String],
			default: 1
		}
	},
	computed: {
		resolvedColumns() {
			return Math.max(1, Number(this.columns) || 1);
		},
		rows() {
			var items_list = this.items;
			const rowItems = [];

			if (!Array.isArray(this.items)) {
				items_list = [];
				for (const [key, value] of Object.entries(this.items)) {
					items_list.push({key: key, value: value });
				}
			}

 			for (let index = 0; index < items_list.length; index += this.resolvedColumns) {
				rowItems.push(items_list.slice(index, index + this.resolvedColumns));
			}

			return rowItems;
		},
		hasValueSlot() {
			return !!this.$scopedSlots.value;
		}
	}
}
</script>

<style scoped>
.k-key-value {
	display: grid;
	font-size: 12px;
	gap: 0.25rem;
}

.k-key-value-row {
	display: grid;
	grid-template-columns: repeat(var(--columns), minmax(0, 1fr));
	gap: 0.5rem;
	padding: 0.25rem 0.5rem;
}

.k-key-value-pair {
	display: grid;
	grid-template-columns: var(--key-width) 1fr;
	gap: 0.5rem;
	align-items: center;
}

.k-key-value-row--dark {
	background-color: rgba(0, 0, 0, 0.2);
	border-radius: 4px;
}

.k-key-value-key {
	overflow: hidden;
}

.k-key-value-value {
	overflow: hidden;
}
</style>